import { Component, ViewChild, TemplateRef, ViewEncapsulation, AfterViewInit, ChangeDetectorRef, ElementRef, OnDestroy } from '@angular/core';
import { MatRowDef, MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatDialogModule, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { CommonModule, NgIf } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatPaginator, MatPaginatorIntl, MatPaginatorModule, PageEvent } from '@angular/material/paginator';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatSelectModule } from '@angular/material/select';
import { MatIcon, MatIconModule } from '@angular/material/icon';
import { MatSlideToggle } from '@angular/material/slide-toggle';
import { MatOptionModule } from '@angular/material/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatExpansionModule } from '@angular/material/expansion';
import { CompanyAttributes, PaymentMethodsAttributes } from '@albatrosdeveloper/ave-models-package';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CompanyService } from '../../configuration/company/company.service.service';
import PaymentMethodAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/payment-masters/payment-methods/payment-methods.entity';
import { MatSidenavContainer } from '@angular/material/sidenav';
import { MatMenuModule } from '@angular/material/menu';
import { IUpdatePaymentMethod } from './interfaces/update-payment-method.interface';
import { PaymentMethodService } from './payment-method.service';
import { CustomMatPaginatorIntl } from 'app/mock-api/common/customPaginatorIntl';
import { IPaginationResult, IRequestResult } from 'app/common/interfaces';
import { PaymentConditionTypeEnum } from '@albatrosdeveloper/ave-models-package/lib/enums';
import { Subscription } from 'rxjs';
import { SearchService } from 'app/layout/common/search-page/search-page.service';
import { StatusFiltersComponent } from '../../filters/status-filters/status-filters.component';
import { FilterComponent } from 'app/common/components/filter/filter.component';
import { ConfigurationFiltersComponent } from '../../filters/configuration-filters/configuration-filters.component';
import { FinanceFiltersComponent } from '../../filters/finance-filters/finance-filters.component';
import { IFilters } from '../../filters/interfaces/filterInterface';
import { HoverMenuDirective } from "@fuse/directives/hover-menu/hover-menu.directive";

@Component({
  selector: 'app-payment-method',
  templateUrl: './payment-method.component.html',
  styleUrls: ['./payment-method.component.scss'],
  standalone: true, 
  imports: [
    CommonModule,
    MatTableModule,
    MatDialogModule,
    MatButtonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSortModule,
    MatPaginatorModule,
    MatIcon,
    MatSlideToggle,
    MatSelectModule,
    MatOptionModule,
    MatTooltipModule,
    MatExpansionModule,
    MatMenuModule,
    MatButtonModule,
    MatIconModule,
    MatRowDef,
    MatSidenavContainer,
    FormsModule,
    FilterComponent,
    FinanceFiltersComponent,
    StatusFiltersComponent,
    ConfigurationFiltersComponent,
    HoverMenuDirective
  ],
  providers: [
    { provide: MatPaginatorIntl, useClass: CustomMatPaginatorIntl },
  ],
})
export class PaymentMethodComponent implements AfterViewInit, OnDestroy {
  displayedColumns: string[] = [
    "name",
    "company",
    "statusId",
    "action"
  ];

  dataSource = new MatTableDataSource<PaymentMethodAttributes>([]);

  totalItems: number = 0;
  search: string = '';
  pageSize: number = 50;
  pageIndex: number = 1;
  sortActive: keyof PaymentMethodAttributes = "name";
  sortDirection: "ASC" | "DESC" = "ASC";

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  dialogRefAdd: MatDialogRef<any>;
  dialogRefEdit:MatDialogRef<any>;

  currentUpdatePaymentMethod: IUpdatePaymentMethod | undefined;

  companyList: CompanyAttributes[] = [];
  companyFilterList: CompanyAttributes[] = []
  paymentTypeList: string [] = Object.values(PaymentConditionTypeEnum)

  @ViewChild("addModal") addModal!: TemplateRef<any>;
  @ViewChild("editModal") editModal!: TemplateRef<any>;
  @ViewChild("deleteDialog") deleteDialog!: TemplateRef<any>;
  @ViewChild("searchInput") searchInput!: ElementRef;

  //BUSCADOR
  searchSubscription: Subscription;

    form: FormGroup
    selectedStatuses: number [] = [];

  // Lazy loading flags
  loadFiltersData = false;

  constructor(
    private paymentMethodService: PaymentMethodService,
    private readonly companyService: CompanyService,
    private readonly searchService: SearchService,
    private dialog: MatDialog,
    private snackBar: MatSnackBar,
    private cdr: ChangeDetectorRef,
    private fb: FormBuilder
  ) {
         this.form = this.fb.group({
      companyId:[],
      paymentModelId: []
    });
   }

  ngAfterViewInit(): void {
    this.onHandleSearch();
    this.findAllWithCount();
    // this.paymentTypeList = Object.entries(PaymentMethodTypeEnum).map(([key, value]) => ({
    //   key: key as PaymentMethodTypeEnum,  // Aseguramos el tipo correcto
    //   value
    // }));
  }

  applyFilter(filterValue: string) {
    this.pageIndex = 1
    this.search = filterValue
    this.findAllWithCount()
  }

  public onHandleSearch(){
    this.searchSubscription = this.searchService.searchTerm$
      .subscribe(term => {
        this.pageIndex = 1
        this.search = term
        this.findAllWithCount()
      });
  }

  onFilterPanelOpened(): void {
    this.loadFiltersData = true;
  }

  findAllWithCount(): void {
    let filter: IFilters = {
      companyId: this.form.get("companyId")?.value,
      paymentModelId: this.form.get("paymentModelId")?.value,
      status: this.selectedStatuses.length ? this.selectedStatuses : null

    }
    let options = { currentPage: this.pageIndex, limitPerPage: this.pageSize, search: this.search, sort: this.sortActive, sortDirection: this.sortDirection }

    this.paymentMethodService.findAllWithCount(options,filter).subscribe({
      next: (res: IPaginationResult<PaymentMethodsAttributes>) => {
        this.dataSource.data = res?.data?.[0]?.data ?? [];
        this.totalItems = res?.data?.[0]?.pageInfo?.[0]?.total ?? 0;
      },
      error: (err) => {
        this.snackBar.open(err.error.message || "Error al obtener métodos de pago","Cerrar",{ duration: 5000});
      },
    })
  }

  changeSort(e) {
    this.sortActive = e.active
    this.sortDirection = e.direction
    this.findAllWithCount()
  }

  changePage(e: PageEvent) {
    this.pageIndex = (e.pageIndex + 1)
    this.pageSize = e.pageSize
    this.findAllWithCount()
  }



  getAllCompanies(): void {
    this.companyService.findToComboBox().subscribe({
      next: (res: IRequestResult<CompanyAttributes[]>) => {
        this.companyList = res.data;
        this.companyFilterList = this.companyList.slice();
      },
      error: (err) => {
        this.snackBar.open(err.error.message || "Error al obtener compañias.","Cerrar",{ duration: 5000});
      }
    });
  }

  getTypeLabel(type: string): string {
    const labels = {
      [PaymentConditionTypeEnum.CREDIT]: 'Crédito',
      [PaymentConditionTypeEnum.DEBIT]: 'Contado',
    };
    return labels[type] || type;
  }

  clearFilters(): void {
    this.form.reset({
      companyId: [],
      paymentModelId: []
    });
    this.findAllWithCount();
  }

  openEditModal(paymentMethod: PaymentMethodsAttributes): void {
    this.getAllCompanies()
    this.currentUpdatePaymentMethod = {
      ...paymentMethod,
      companyId: paymentMethod.company ? paymentMethod.company._id.toString() : ""
    };

    this.dialogRefEdit = this.dialog.open(this.editModal, { width: '90%', disableClose: true })
    // this.dialogRefEdit.afterClosed().subscribe((result) => result && this.updatePaymentMethod(paymentMethod._id.toString()));
    this.dialogRefEdit.afterClosed().subscribe((result) => { result });
  }

  updatePaymentMethod(id: string): void {
    if (this.currentUpdatePaymentMethod) {
      const updatedPaymentMethod: IUpdatePaymentMethod = { ...this.currentUpdatePaymentMethod};
      this.paymentMethodService.update(id, updatedPaymentMethod).subscribe({
        next: () => {
          this.snackBar.open('Registro actualizado con éxito', 'Cerrar', { duration: 3000 });
          this.findAllWithCount();
          this.dialogRefEdit.close()
        },
        error: (err) => {
          this.snackBar.open(err.error.message || 'Error al actualizar el registro', 'Cerrar', { duration: 3000 });
        }
      });
    }
  }

  onStatusChange(event: boolean, paymentMethod: PaymentMethodsAttributes): void {
    const originalStatusId = paymentMethod.statusId;
    const updatedStatusId = event ? 1 : 0;
    const updatedPaymentMethod = { ...paymentMethod, statusId: updatedStatusId };

    this.paymentMethodService.update(paymentMethod._id.toString(), updatedPaymentMethod).subscribe({
      next: () => {
        this.findAllWithCount();
      },
      error: () => {
        paymentMethod.statusId = originalStatusId; // Volver al estado original si falla
        this.snackBar.open('Error al actualizar el estado.', 'Cerrar', { duration: 3000 });
        this.findAllWithCount();
      }
    });
  }

  openDeleteDialog(paymentMethod: PaymentMethodsAttributes): void {
    this.dialog
      .open(this.deleteDialog, { data: paymentMethod, panelClass: "delete-modal" , disableClose:true})
      .afterClosed()
      .subscribe((result) => result && this.delete(paymentMethod._id.toString()));
  }

  delete(id: string): void {
    this.paymentMethodService.remove(id).subscribe(() => {
      this.findAllWithCount();
      this.snackBar.open('Registro eliminado con éxito', 'Cerrar', { duration: 3000 });
    });
  }

  ngOnDestroy(): void {
    this.searchSubscription.unsubscribe();
  }
}
